// extracted by mini-css-extract-plugin
export default {"header":"styles_header__YU8Zn","logo":"styles_logo__uO33l","logoImg":"styles_logoImg__k1CxY"};